export default {
    intro: `단어 속에 숨어 있는 씨앗글자를 찾아봐요!<br />
            오늘은 { first }, { second }을(를) 배워볼 거예요.`,
    options: {
        textbook: '교과서에 나오는 단어',
        page: '교과서',
    },
    header: {
        round: ({ values }: { values: { round: number } }) => {
            const { round } = values;
            return `${round === 1 ? '첫 번째' : '두 번째'} 글자`;
        },
        title: {
            word: '글자',
            example1: '예시 단어1',
            example2: '예시 단어2',
            check: '배운 단어 확인',
            question: '단어 문제',
            meaning: '의미 관계 확인',
            meaningQuestion: '의미 관계 문제',
        },
    },
    indicator: {
        word: '씨앗글자의 모양, 소리, 뜻을 배워요.',
        example1: '씨앗글자가 단어에서 어떻게 쓰이는지 배워요.',
        example2: '씨앗글자가 단어에서 어떻게 쓰이는지 배워요.',
        check: '씨앗글자가 들어간 두 단어를 배워요. ',
        question: '두 단어 중 "{ reading }({ cn })" 자가 사용된 단어는 무엇일까요?',
        meaning: '씨앗글자가 단어에서 어떻게 쓰이는지 배워요.',
        meaningQuestion: '{ first }과(와) { second }의 관계는 무엇일까요?',
        // 관계 설명(앞문장) — 관계 타입별(0유의/1반의/2상하/3동형/4다의). { first }/{ second }/{ sound }/{ meaning1 }/{ meaning2 } 보간
        desciption: {
            0: '<strong>{ first }</strong>과(와) <strong>{ second }</strong>는(은) 뜻이 비슷해요.',
            1: '<strong>{ first }</strong>과(와) <strong>{ second }</strong>는(은) 뜻이 서로 반대예요.',
            2: '<strong>{ first }</strong>과(와) <strong>{ second }</strong>의 뜻을 포함해요.',
            3: '<strong>{ first }</strong>과(와) <strong>{ second }</strong>는(은) 모두 { sound }(이)라고 읽지만 뜻이 달라요.',
            4: '<strong>{ first }</strong>는(은) <strong>{ meaning1 }</strong>(이)라는 뜻도 있고, <strong>{ meaning2 }</strong>(이)라는 뜻도 있어요.',
        },
    },
    toast: {
        cube: ({ values }: { values: { isTeacher: boolean } }) => {
            const { isTeacher } = values;
            return isTeacher
                ? '학생들이 직접 큐브를 돌리며 익히는 구간이에요.'
                : '직접 큐브를 돌리며 글자를 익혀 보세요.';
        },
        wrongAnswer: {
            lead: '다시 생각해 볼까요?',
            body: '뜻을 보고 알맞은 단어를 골라 보세요.',
        },
    },

    description: ({ values }: { values: { type: number } }) => {
        const { type } = values;
        if (type === 0) {
            return '유의';
        }
        if (type === 1) {
            return '반의';
        }
        if (type === 2) {
            return '상하';
        }
        if (type === 3) {
            return '동형';
        }
        if (type === 4) {
            return '다의';
        }
        if (type === 5) {
            return '없음';
        }
        return '없음';
    },
    relationResult: {
        lead: '이런 관계를',
        // 뒷문장 꼬리 — 동형(3)만 받침이 있어 '이라고'
        tail: ({ values }: { values: { type: number } }) => (values.type === 3 ? '이라고 해요.' : '라고 해요.'),
    },
    result: {
        correct: '정답',
        incorrect: '오답',
        selected: '선택',
    },
    buttons: {
        next: '다음으로',
        learn: '단어 학습하기',
        nextLearn: '다음 단어 학습',
        collectWord: '단어 모아보기',
        check: '배운 단어 확인',
        seoncdLearn: '두 번째 글자 학습',
        relation: '의미 관계 학습',
        prev: '이전으로',
        finishStudy: '학습 완료하기',
        desciption: '설명보기',
    },
    guide: {
        cube: '큐브를 클릭하여 돌려보세요.',
    },
    study: {
        example: '예문',
        meaning: '뜻',
    },
};
